export const Subscriptions_Table_Head = [
  "reference number",
  "policy number",
  "cover type",
  "amount",
  "policy amount",
  "subscription_amount",
  "business class",
  "datecreated",
]

export const Table_Headers = [
  "Driver's  ID",
  "Driver Name",
  "Address",
  "Phone Number",
  "Email",
  "ID Type",
  "ID Number",
  "Momo Details",
  "Bank Details",
  "Date Created",
  "Staff/Agent",
  "Total Collection",
  "Total Amount Withdrawn",
  "Total Amount used",
  "Account Balance",
  "",
]

export const Tax_HEADERS = [
  "Transaction Reference",
  "Commission Type",
  "Policy Number",
  "Class/Subclass",
  "Premium",
  "Commission",
  "Tax Rate ",
  "tax amount",
  "status",
]

export const Companies_HEADERS = [
  "name",
  "Initials",
  "email",
  "phone",
  "tin number",
  "address",
  "createdAt",
]

export const Commissions_HEADERS = [
  "Commission Type",
  "Policy No.",
  "Class",
  "Subclass",
  "Basic Premium",
  "NIC Fees",
  "Rate",
  "Gross Commission",
  // "Tax",
  "Net Commission",
  "Payee",
  // "Insurance Company",
  "Date created",
  "Status",
]
export const Policy_HEADERS = [
  "Policy No",
  "Endorsement No.",
  "Policyholder",
  "Class/Subclass",
  "Cover Type",
  "Risk ID",
  "Premium",
  "Payment Channel",
  "Staff/Subagent",
  "Status",
  "Start Date",
  "Expiry Date",
]
export const Customers_HEADERS = [
  "name",
  "email",
  "phone number",
  "customer type",
  "createdAt",
]

// Beneficiaries and their percentages
